import { render, staticRenderFns } from "./CategoryListItem.vue?vue&type=template&id=6ed0eb90&scoped=true&"
import script from "./CategoryListItem.vue?vue&type=script&lang=js&"
export * from "./CategoryListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryListItem.vue?vue&type=style&index=0&id=6ed0eb90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed0eb90",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F01-atoms%2Fcategory-list-item%2FCategoryListItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports